export class CreateQuoteRefusalReasonModel {
  public descricao = ''
}

export class EditQuoteRefusalReasonModel {
  public id = 0
  public descricao = ''
  public ativo = 'S'
}

export class SearchQuoteRefusalReasonModel {
  public descricao = ''
}

export class CreateQuoteRefusalReasonResponse {
  public response: any
}
export class EditQuoteRefusalReasonResponse {
  public response: any
}
export class PagedQuoteRefusalReasonResponse {
  public response: any
}
